










































import { Component, Vue, PropSync } from 'vue-property-decorator';

@Component
export default class LLIModal extends Vue {
  @PropSync('active', { default: false }) pActive!: boolean;
}
